export interface IWind {
    [key: string]: number[]
}

export const wind: IWind = {
    'WTG000': [-2.6, 0.5],
    'WTG001': [-2.6, 0.5],
    'WTG002': [-2.6, 0.5],
    'WTG003': [-2.6, 0.5],
    'WTG004': [-2.6, 0.5],
    'WTG005': [-2.6, 0.5],
    'WTG006': [-2.6, 0.5],
    'WTG007': [-2.6, 0.5],
    'WTG008': [-2.6, 0.5],
    'WTG009': [-2.6, 0.5],
    'WTG010': [-2.6, 0.5],
    'WTG011': [-2.6, 0.5],
    'WTG012': [-2.6, 0.5],
    'WTG013': [-2.6, 0.5],
    'WTG014': [-2.6, 0.5],
    'WTG015': [-2.6, 0.5],
    'WTG016': [-2.6, 0.5],
    'WTG017': [-2.6, 0.5],
    'WTG018': [-2.6, 0.5],
    'WTG019': [-2.6, 0.5],
    'WTG020': [-2.6, 0.5],
    'WTG021': [-2.6, 0.5],
    'WTG022': [-2.6, 0.5],
    'WTG023': [-2.6, 0.5],
    'WTG024': [-2.6, 5.4],
    'WTG025': [-2.6, 5.4],
    'WTG026': [-2.6, 5.4],
    'WTG027': [-2.6, 5.4],
    'WTG028': [-2.6, 5.4],
    'WTG029': [-2.6, 5.4],
    'WTG030': [-2.6, 5.4],
    'WTG031': [-2.6, 5.4],
    'WTG032': [-2.6, 5.4],
    'WTG033': [-2.6, 5.4],
    'WTG034': [-2.6, 5.4],
    'WTG035': [-2.6, 5.4],
    'WTG036': [-2.6, 5.4],
    'WTG037': [-2.6, 5.4],
    'WTG038': [-2.6, 5.4],
    'WTG039': [-2.6, 5.4],
    'WTG040': [-2.6, 5.4],
    'WTG041': [-2.6, 5.4],
    'WTG042': [-2.6, 5.4],
    'WTG043': [-2.6, 0.5],
    'WTG044': [-2.6, 5.4],
    'WTG045': [-2.6, 5.4],
    'WTG046': [-2.6, 5.4],
    'WTG047': [-2.6, 5.4],
    'WTG048': [-2.6, 5.4],
    'WTG049': [-2.6, 5.4],
    'WTG050': [-2.6, 5.4],
    'WTG051': [-2.6, 5.4],
    'WTG052': [-2.6, 5.4],
    'WTG053': [-2.6, 5.4],
    'WTG054': [-2.6, 5.4],
    'WTG055': [-2.6, 5.4],
    'WTG056': [-2.6, 5.4],
    'WTG057': [-2.6, 5.4],
    'WTG058': [-2.6, 5.4],
    'WTG059': [-2.6, 5.4],
    'WTG060': [-2.6, 5.4],
    'WTG061': [-2.6, 5.4],
    'WTG062': [-2.6, 5.4],
    'WTG063': [-2.6, 5.4],
    'WTG064': [-2.6, 5.4],
    'WTG065': [-2.6, 5.4],
    'WTG066': [-2.6, 5.4],
    'WTG067': [-2.6, 5.4],
    'WTG068': [-2.6, 5.4],
    'WTG069': [-2.6, 5.4],
    'WTG070': [-2.6, 5.4],
    'WTG071': [-2.6, 5.4],
}
